import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import CloseIcon from '../../icons/close.svg';

// Components
import Modal from '../Modal';
import Paper from '../Paper';
import Actions from '../Actions';
import Button from '../Button';

// Actions
import { clearCart } from '../../state/modules/cart/actions';

import styles from './RepeatOrderConflict.styl';

const cx = classNames.bind(styles);

class RepeatOrderConflict extends PureComponent {
  static defaultProps = {
    className: '',
    isOpen: false,
  };

  static propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    clearCart: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    addToCart: PropTypes.func.isRequired,
  };

  addToCart = () => {
    const addToCart = this.props.addToCart();

    if (addToCart instanceof Promise) {
      addToCart.then(() => {
        this.props.onClose();
      });
    } else {
      this.props.onClose();
    }
  };

  clearCart = () => {
    this.props.clearCart().then(() => {
      this.addToCart();
    });
  };

  render() {
    const { className, isOpen, onClose } = this.props;

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <Paper className={cx('RepeatOrderConflict', className)}>
          <div className={cx('RepeatOrderConflict__closeButton')} onClick={onClose}>
            <CloseIcon width={16} height={16} />
          </div>
          <div className={cx('RepeatOrderConflict__text')}>
            <FormattedMessage id="modal.orderConfict" />
          </div>
          <Actions align="center">
            <Button className={cx('RepeatOrderConflict__button')} onClick={this.clearCart} link>
              <FormattedMessage id="button.clear" />
            </Button>
            <Button className={cx('RepeatOrderConflict__button')} onClick={this.addToCart}>
              <FormattedMessage id="button.add" />
            </Button>
          </Actions>
        </Paper>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ clearCart }, dispatch);

export default connect(null, mapDispatchToProps)(RepeatOrderConflict);
